import { compose } from 'app/core/functional/functions';

interface DateQuarterFromTo { from: Date | null; to: Date | null };

const dateWith = fn => date => {
  const clone = new Date(date.getTime());
  fn(clone);
  return clone;
}

const months = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December'
];

export function monthName(date) {
  return months[date.getMonth()];
}

export function removeTimeZone(date: Date) {
  return new Date(date.getTime() - date.getTimezoneOffset() * 60000);
}

export const min = (d1, d2) => d1 < d2 ? d1 : d2;
export const max = (d1, d2) => d1 > d2 ? d1 : d2;

export const addTime = (h, m, s, ms) => dateWith(d =>
  d.setHours(
    d.getHours() + h,
    d.getMinutes() + m,
    d.getSeconds() + s,
    d.getMilliseconds() + ms)
);

export const addMilliseconds = milliseconds => addTime(0, 0, 0, milliseconds);
export const addSeconds = seconds => addTime(0, 0, seconds, 0);
export const addMiniutes = minutes => addTime(0, minutes, 0, 0);
export const addHours = hours => addTime(hours, 0, 0, 0);
export const addDays = days => dateWith(d => d.setDate(d.getDate() + days));
export const addMonths = month => dateWith(d => d.setMonth(d.getMonth() + month));
export const addYears = years => dateWith(d => d.setFullYear(d.getFullYear() + years));
export const setDay = day => dateWith(d => d.setDate(day));
export const newDate = () => dateWith(d => d.setHours(0, 0, 0, 0))(new Date());

export function fromDay(day: number): Date {
  return setDay(day)(new Date(newDate().getFullYear(), 0));
}

export function dayOfYear(date: Date): number {
  const startOfYear = new Date(date.getFullYear(), 0, 0);
  const millisecondsPerDay = 24 * 60 * 60 * 1000;
  return Math.round((date.getTime() - startOfYear.getTime()) / millisecondsPerDay);
}

export const endOfMonth = (date) => compose(setDay(1), addMonths(1), addMilliseconds(-1))(date);

export const minDate = () => new Date(0);
export const maxDate = () => new Date(10000, 0, 0, 0, 0, 0);

const quarters = [
  'January',
  'April',
  'July',
  'October'
];

export function quarter(date) {
  const month = quarters
    .slice()
    .reverse()
    .map(m => months.indexOf(m))
    .find(m => m <= date.getMonth());
  const start = new Date(date.getFullYear(), month, 1);
  const end = compose(addMonths(3), addDays(-1))(start);
  return { start, end };
}

export function ISOStringForCurrentTime(date: Date): string {
  return (new Date(date.getTime() - (date).getTimezoneOffset() * 60000)).toISOString().slice(0, -1)
};

export function getThisQuarter(): number {
  const today = new Date();
  return Math.floor((today.getMonth() + 3) / 3);
};

export function getPreviousQuarter(): { quarter: number; isPreviousYear: boolean } {
  const thisQuarter = getThisQuarter();
  if (thisQuarter === 1) {
    return { quarter: 4, isPreviousYear: true };
  } else {
    return {quarter: thisQuarter - 1, isPreviousYear: false};
  }
}

export function getFromToQuarter(quarter: number = null, isPreviousYear: boolean = false): DateQuarterFromTo {
  const _obj: DateQuarterFromTo = {
    from: null,
    to: null,
  }
  const _time = new Date();
  const _quarter = quarter || getThisQuarter();
  const _minusYear = (isPreviousYear) ? 1 : 0;
  switch (_quarter) {
    case 1:
      _obj.from = new Date(_time.getFullYear() - _minusYear, 0, 1, 0, 0, 0);
      _obj.to = new Date(_time.getFullYear() - _minusYear, 3, 0, 23, 59, 59);
      break;
    case 2:
      _obj.from = new Date(_time.getFullYear() - _minusYear, 3, 1, 0, 0, 0);
      _obj.to = new Date(_time.getFullYear() - _minusYear, 6, 0, 23, 59, 59);
      break;
    case 3:
      _obj.from = new Date(_time.getFullYear() - _minusYear, 6, 1, 0, 0, 0);
      _obj.to = new Date(_time.getFullYear() - _minusYear, 9, 0, 23, 59, 59);
      break;
    case 4:
      _obj.from = new Date(_time.getFullYear() - _minusYear, 9, 1, 0, 0, 0);
      _obj.to = new Date(_time.getFullYear() - _minusYear, 12, 0, 23, 59, 59);
      break;
  }
  return _obj;
};
